import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /f?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fasting_f_models_from_creos~1
			landing: {
				experiment: () =>
					import(
						/* webpackChunkName: "landing" */ '@/modules/Landing/instances/experiments/web_fasting_f_models_from_creos'
					),
			},
			funnel: {
				id: 'ob-female-funnel-models-from-creos',
				locale: ['en'],
			},
		},
	},
]

export default config
